import {
  AdjustmentsHorizontalIcon,
  ArrowDownTrayIcon,
  EllipsisVerticalIcon
} from '@heroicons/react/24/outline'

const StatCards = ({ cards = [] }) => {
  return (
    <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4'>
      {cards.map((card, idx) => (
        <div key={idx} className={`rounded shadow ${card.color} text-white flex flex-col justify-between`}>
          <div className='flex justify-between items-start p-4 pb-0'>
            <h2 className='text-lg font-semibold'>{card.title}</h2>

            <div className='flex items-center gap-2'>
              <AdjustmentsHorizontalIcon className='w-4 h-4' />
              <ArrowDownTrayIcon className='w-4 h-4' />
              <EllipsisVerticalIcon className='w-4 h-4' />
            </div>

          </div>

          <div className='px-4 pt-2 text-3xl font-bold'>
            {card.value}{' '}
            <span className='text-base font-normal'>{card.unit}</span>
          </div>

          <div className='mt-4 bg-opacity-10 p-2 px-4 text-sm text-white'>
            {card.sub}
          </div>
        </div>
      ))}
    </div>
  )
}

export default StatCards
